{
    "Accessibility": {
        "SvgTitle": {
            "agentIndicator": "エージェントインジケーター",
            "botIndicator": "ボットインジケーター",
            "chatIcon": "チャットアイコン",
            "checkboxIcon": "チェックボックスアイコン",
            "chevronDown": "下向きシェブロン",
            "chevronRight": "右向きシェブロン",
            "clockIcon": "時計アイコン",
            "closeIcon": "閉じるアイコン",
            "endChatIcon": "チャット終了アイコン",
            "feedbackIcon": "フィードバックアイコン",
            "menuIcon": "メニューアイコン",
            "muteIcon": "ミュートアイコン",
            "newMessageIcon": "新規メッセージアイコン",
            "radioIcon": "ラジオボタンアイコン",
            "ratingStarIcon": "評価スターアイコン",
            "receiptIcon": "レシートアイコン",
            "ringIcon": "Ringアイコン",
            "sendIcon": "送信アイコン",
            "themeIcon": "テーマアイコン",
            "thumbsDownIcon": "サムズダウンアイコン",
            "thumbsUpIcon": "サムズアップアイコン",
            "unmuteIcon": "ミュート解除アイコン",
            "userIcon": "ユーザーアイコン"
        }
    },
    "Components": {
        "Alert": {
            "ariaLabel": "閉じる",
            "endChatError": "セッションを終了できません。もう一度お試しください",
            "sessionEnded": "セッションが終了しました。トップページにリダイレクトされました。",
            "networkError": "セッション接続時に問題が発生しました。もう一度お試しください",
            "messageError": "申し訳ありません。現在チャットサポートはご利用いただけません。 <a href='https://ring.com/support'>Ringヘルプ</a> のコンテンツをご確認いただくか、数分後にもう一度お試しください。",
            "messageLabel": "警告",
                "pendingTimeout": "申し訳ありません。もう一度お試しください。"
        },
        "Body": {
            "latestMessage": "最近のメッセージ",
            "loadMessages": "メッセージを読み込む",
            "newMessage": "新規メッセージ",
            "title": "どのようなサポートをご希望ですか？",
            "subtitle": "こんにちは。Ringカスタマーサポート担当です。どのようなサポートをご希望ですか?"
        },
        "Bubble": {
            "ariaLabel": "チャットメッセージ",
            "sourceTitle": "役立つリンク"
        },
        "Entry": {
            "reasoningAriaLabel": "思考中",
            "reasonings": {
                "thinkingText": "思考中"
            }
        },
        "Event": {
            "defaultJoin": "Ringのサポート担当者がライブチャットに参加しました。",
            "customerJoin": "ライブチャットに移行しました。",
            "agentJoin": "がライブチャットに参加しました。",
            "defaultLeft": "Ringのサポート担当者がライブチャットから退出しました。",
            "customerLeft": "チャットから退出しました。",
            "agentLeft": "がライブチャットから退出しました。",
            "idle": "しばらく操作が行われていません。何かお困りごとがあればお知らせください。",
            "idleContinue": "すみません、もう少しお時間をいただけますか？",
            "idleEnd": "チャットを終了",
            "returned": "再開いただきありがとうございます！前回の内容を引き続きお手伝いします。"
        },
        "FeedbackCard": {
            "ariaLabelThumbsUp": "高評価",
            "ariaLabelThumbsDown": "低評価",
            "header": "役に立ちましたか?",
            "sent": "貴重なご意見ありがとうございます",
            "thumbsDown": "ご期待に沿えず申し訳ありません。今後の改善に役立てるため、ぜひご意見をお聞かせください。",
            "thumbsDownResponse": "貴重なご意見ありがとうございます。表現を変えてもう一度質問してみてください。",
            "thumbsUp": "お役に立てて嬉しいです！他にご不明な点やご質問があれば、お気軽にお知らせください。",
            "RESPONSE_UNCLEAR": "返答が不明確",
            "ISSUE_UNRESOLVED": "問題を解決できなかった",
            "NOT_HELPFUL": "役に立たなかった"
        },
        "Footer": {
            "ariaLabel": "送信",
            "placeholder": "質問を入力してください...",
            "botText": "このチャットボットは、お客様のご質問に回答するために生成AIを使用しています。生成された回答に含まれる重要な情報については、内容を十分に確認した上で適切な判断を行うようお願いいたします。"
        },
        "Header": {
            "ariaLabelMenu": "その他のメニュー",
            "ariaLabelMinimize": "最小化",
            "badgeTitle": "ベータ版",
            "badgeDisabled": "接続が切断されました",
            "themeLabel": "テーマ",
            "muteLabel": "ミュート",
            "unmuteLabel": "ミュート解除",
            "feedbackLabel": "Give Feedback",
            "endLabel": "チャットを終了"
        },
        "NotificationCard": {
            "ariaLabelClose": "閉じる",
            "ariaLabelOpen": "開く",
            "notification": "新規メッセージ",
            "expand": "クリックして拡大"
        },
        "WidgetIcon": {
            "ariaLabel": "サポートのためのチャット"
        },
        "WelcomeScreen": {
            "ariaLabel": "最小化",
            "button": "チャットを開始",
            "title": "Ringにお問い合わせいただき、ありがとうございます。",
            "subtitleHtml": "本サービスの利用にあたり、お客様は <a href='https://ring.com/terms'>Ringの利用規約</a> に同意したものとみなされます。 このチャットの情報は収集され、記録されることがあります。 個人情報保護に関する情報については、Ringの <a href='https://ring.com/privacy-notice'>プライバシー規約</a> をご覧ください。",
            "loading": "チャットを開始しています...",
            "error": "セッションを開始できません。もう一度お試しください",
            "messageLabel": "ようこそテキスト"
        }
    }
}